<template>
  <div class="container py-5">

    <p>
    <b>TSK誠摯邀請您參加2025台灣微整形美容醫學會！</b>
    <br>讓我們一起揭開新年醫美新篇章，感受來自日本的尖端技術與匠心品質。
    <br><br>🌟 展會亮點搶先看 🌟
    <br>	•	全系列尖針、鈍針型號現場展示<br>	•	日本匠心製造，歡迎至攤位親手體驗TSK針頭的卓越手感
    <br>	•	現場專屬優惠活動與驚喜好禮，帶回新年的第一波好運
    <br><br><b>展會資訊⮕</b><br>展會時間：2025/1/12(日)<br> 展會地點：台北國際會議中心1樓<br> 攤位編號：A3<br><br>讓TSK與您一起邁向專業與信任的高峰，期待您的蒞臨！
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_53.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
